<template>
	<section class="app-container doc-index">
		
		<header class="h1-buttons d-flex justify-content-between">
			<h1>Documentation Index</h1>
			<span class="doc-index__num">{{ articlesCount }} items</span>
		</header>

		<div v-if="treeColumns" class="content">
			<div class="doc-index__trees">
				<div
					class="doc-index__tree"
					v-for="(col, colIndex) in treeColumns"
					:key="colIndex"
				>
					<div
						class="doc-index__item"
						v-for="(colTree, treeIndex) in col.trees"
						:key="treeIndex"
					>
						<header>
							<h2 class="doc-index__item-h">
								{{ normalizeType(colTree.name) }}
							</h2>
							<button
								class="btn btn-secondary"
								v-if="isEditor"
								@click="addArticle(colTree.name)"
							>
								<span>
									<i class="fa-solid fa-plus"></i>
								</span>
								<span class="text">Add {{ normalizeType(colTree.name) }}</span>
							</button>
						</header>
						<child-tree
							v-for="(a, i) in colTree.tree"
							:key="i"
							:article="a"
							:isLast="isLast(i)"
							:isAdmin="isEditor"
							@deletearticle="deleteArticle"
						/>
					</div>
				</div>
			</div>
		</div>

		<div class="doc-index__spinner" v-if="loading">
			<spinner />
		</div>

		<div class="doc-index__error"></div>
		<error-dialog ref="errDialog" />

	</section>
</template>

<script>
import ChildTree from './ChildTree';
import Article from '../../../services/article';
import UtilityFunctions from '../../../util/classes/UtilityFunctions';
import Spinner from '../../shared/Spinner';
import ErrorDialog from '../../shared/ErrorDialog';
import { mapGetters } from 'vuex';

export default {
	name: 'DocumentIndex',
	components: {
		ChildTree,
		Spinner,
		ErrorDialog,
	},
	data: function () {
		return {
			treeColumns: null,
			loading: false,
		};
	},
	mounted() {
		this.listenForArticleDelete();
		this.listenForRemoveType();
		this.distributeColumns();
	},
	methods: {
		isLast: function (index) {
			if (!this.articleTree) return;
			return !this.articleTree[index + 1];
		},
		distributeColumns: function () {
			if (!this.treesByType || !this.treesByType.length) return;
			
			if (this.treeColumns) return;
			let cols = this.treeColumns = [
				{ length: 0, trees: [] },
				{ length: 0, trees: [] },
			];
			
			this.treesByType.forEach((t) => {
				if (cols[0].length == 0 || cols[0].length <= cols[1].length) {
					cols[0].trees.push(t);
					cols[0].length += t.length;
				} else if (cols[0].length > cols[1].length) {
					cols[1].trees.push(t);
					cols[1].length += t.length;
				}
			});
		},
		addArticle: function (type) {
			if (type == 'Others') type = null;
			this.loading = true;
			Article.instance()
				.editArticle({
					title: 'New article',
					html: '<h2>Synopsis</h2><p></p>',
					articleType: type,
				})
				.then((res) => {
					this.addToTree(res.data);
					this.loading = false;
					this.$store.dispatch('fetchIndexArticles');
				})
				.catch((error) => {
					this.loading = false;
					this.$refs.errDialog.show(error);
				});
		},
		addToTree: function (article) {
			let type = article.articleType;
			if (!type) type = 'Others';
			this.treeColumns.forEach((tc) => {
				tc.trees.forEach((t) => {
					if (t.name == type) {
						t.tree.push(article);
					}
				});
			});
		},
		deleteArticle: function (article) {
			this.treeColumns.forEach((tc) => {
				tc.trees.forEach((t) => {
					t.tree = t.tree.filter((a) => a.id != article.id);
				});
			});
		},
		normalizeType: function (type) {
			return UtilityFunctions.normalizeType(type);
		},
		listenForArticleDelete: function () {
			Article.instance().events.on('addtoothers', this.addToOthers);
		},
		listenForRemoveType: function () {
			Article.instance().events.on('removetype', this.removeType);
		},
		addToOthers: function (children) {
			let othersTree;
			this.treeColumns.forEach((tc) => {
				tc.trees.forEach((t) => {
					if (t.name == 'Others') {
						othersTree = t.tree;
					}
				});
			});
			children.forEach((c) => (c.parentArticleId = null));
			othersTree.push(...children);
		},
		removeType: function (id) {
			let article;

			this.treeColumns.forEach((tc) => {
				tc.trees.forEach((t) => {
					let art = UtilityFunctions.findInTree(id, t.tree);
					if (art) {
						article = art;
						article.articleType = null;
						t.tree = t.tree.filter((a) => a != art);
					}
				});
			});

			if (!article) return;

			this.treeColumns.forEach((tc) => {
				tc.trees.forEach((t) => {
					if (t.name == 'Others') {
						t.tree.push(article);
					}
				});
			});
		},
	},
	computed: {
		...mapGetters(['isEditor']),
		articlesCount: function () {
			return this.$store.getters.articlesCount(this.isEditor);
		},
		treesByType: function () {
			return this.$store.getters.allTreesByType(this.isEditor);
		},
		storeLoading: function () {
			return this.$store.state.loading;
		},
	},
	watch: {
		treesByType: function () {
			this.distributeColumns();
		},
		storeLoading: function () {
			if (this.storeLoading == 'index-articles') {
				this.loading = true;
			} else {
				this.loading = false;
			}
		},
	},
	destroyed() {
		Article.instance().events.off('addtoothers', this.addToOthers);
		Article.instance().events.off('removetype', this.removeType);
	},
};
</script>

<style scoped>
.doc-index {
	height: calc(100vh - 70px);
	overflow: auto;
}

.doc-index__content {
	width: 100%;
}
.doc-index__index {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(590px, 1fr));
	gap: 24px;
}
.doc-index__item-h {
	margin-bottom: 2rem;
	color: var(--textPrimary);
}
.doc-index__trees {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
	gap: 20px;
}
.doc-index__item {
	margin-bottom: 1.5rem;
}
.add-article-btn {
	color: var(--textAdmin);
	background: transparent;
	border: none;
	display: flex;
	align-items: center;
	padding: 0;
}
.add-article-btn-text {
	color: var(--textAdmin);
}
.doc-index__num {
	color: #a6a6a6;
	font-weight: normal;
}


.doc-index__trees {

}

.doc-index__trees .doc-index__tree {

}

.doc-index__trees .doc-index__tree .doc-index__item {
	border: 1px solid #DDD;
	border-radius: 0.3em;
}

.doc-index__trees .doc-index__tree .doc-index__item > header {
	border-bottom: 1px solid #DDD;
	display: flex;
	justify-content: space-between;
	padding-bottom: 1em;
	margin-bottom: 1em;
	padding: 1em;
	background: rgb(0,0,0,0.05);
}

.doc-index__trees .doc-index__tree .doc-index__item > header h2 {
	margin: 0;
	padding: 0;
}

.doc-index__trees .doc-index__tree .doc-index__item > header .btn {
}

.doc-index__trees .doc-index__tree .doc-index__item > header .btn i {
	padding-right: 0.5em;
}
.doc-index__trees .doc-index__tree .doc-index__item > .item {
	padding: 0 1em 0 1.5em;
}

</style>
